export var isAuthorized = function isAuthorized(authorities, roles, sourceClientId) {
  return authorities && roles && authorities.some(function (e) {
    return e.client && e.client.clientId && e.client.clientId === sourceClientId;
  }) && roles.some(function (e) {
    return e.client && e.client.clientId && e.client.clientId === sourceClientId;
  });
};